import { apiClient } from "./apiclient";

// GET all tickets
export const getAllTickets = (token) =>
  apiClient.get("/tickets", {
    headers: { Authorization: `Bearer ${token}` },
  });

// GET active employees for assignee dropdown
export const getActiveEmployees = (token) =>
  apiClient.get("/tickets/active-employees", {
    headers: { Authorization: `Bearer ${token}` },
  });
  
  // GET all project modules for module dropdown
export const getProjectModules = (token) =>
  apiClient.get("/project-modules", {
    headers: { Authorization: `Bearer ${token}` },
  });


// CREATE ticket — sends multipart FormData
export const createTicket = (formData, token) =>
  apiClient.post("/tickets", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      // Do NOT set Content-Type — axios sets multipart/form-data automatically
    },
  });

// UPDATE ticket
export const updateTicket = (id, formData, token) =>
  apiClient.put(`/tickets/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// DELETE ticket
export const deleteTicket = (id, token) =>
  apiClient.delete(`/tickets/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// UPDATE STATUS only
export const updateTicketStatus = (id, status, token) =>
  apiClient.patch(`/tickets/${id}/status`, { status }, {
    headers: { Authorization: `Bearer ${token}` },
  });
// DOWNLOAD attachment — by attachment ID, matches TicketController's
// GET /tickets/attachments/{attachmentId}
export const downloadAttachment = (attachmentId, token) =>
  apiClient.get(`/tickets/attachments/${attachmentId}`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });

// GET most recent comment on any ticket assigned to me (for dashboard recent activity)
export const getMyRecentTicketComment = (token) =>
  apiClient.get("/tickets/my-recent-comment", {
    headers: { Authorization: `Bearer ${token}` },
  });
  // GET ticket statuses for Change Status modal
export const getTicketStatuses = (token) =>
  apiClient.get("/tickets/statuses", {
    headers: { Authorization: `Bearer ${token}` },
  });